module.exports = __webpack_public_path__ + "img/3.91c80280.jpg";